const DEFAULT_META_PIXEL_ID = '3481244185387277';
const TRACKED_BOOK_SLUGS = new Set(['macros-made-easy-for-women']);

export const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID || DEFAULT_META_PIXEL_ID;

export const isMetaPixelEnabled = () =>
  Boolean(META_PIXEL_ID && !String(META_PIXEL_ID).startsWith('%') && typeof window !== 'undefined');

let hasInitializedFallbackPixel = false;

const ensureMetaPixel = () => {
  if (!isMetaPixelEnabled()) return false;

  if (typeof window.fbq === 'function') return true;

  const fbq = function metaPixelQueue() {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, arguments);
      return;
    }
    fbq.queue.push(arguments);
  };

  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && !document.querySelector('script[src*="connect.facebook.net/en_US/fbevents.js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  if (!hasInitializedFallbackPixel) {
    hasInitializedFallbackPixel = true;
    window.fbq('init', META_PIXEL_ID);
  }

  return true;
};

export const createMetaEventId = (prefix) => {
  const randomPart =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}-${randomPart}`;
};

export const getMetaBrowserIds = () => {
  if (typeof document === 'undefined') return {};

  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [key, ...valueParts] = cookie.trim().split('=');
    if (key) acc[key] = valueParts.join('=');
    return acc;
  }, {});

  return {
    fbp: cookies._fbp || '',
    fbc: cookies._fbc || '',
  };
};

export const trackMetaEvent = (eventName, params = {}, eventId) => {
  if (!ensureMetaPixel()) return;

  if (eventId) {
    window.fbq('track', eventName, params, { eventID: eventId });
    return;
  }

  window.fbq('track', eventName, params);
};

export const trackMetaPageView = () => {
  trackMetaEvent('PageView');
};

export const getBookMetaParams = (book) => ({
  content_ids: [book.slug],
  content_name: book.title,
  content_type: 'product',
  contents: [{ id: book.slug, quantity: 1, item_price: Number(book.price) }],
  currency: 'USD',
  value: Number(book.price),
});

export const isMetaTrackedBook = (book) => Boolean(book && TRACKED_BOOK_SLUGS.has(book.slug));

export const trackBookViewContent = (book) => {
  if (!isMetaTrackedBook(book)) return;
  trackMetaEvent('ViewContent', getBookMetaParams(book));
};

export const trackBookInitiateCheckout = (book, eventId) => {
  if (!isMetaTrackedBook(book)) return;
  trackMetaEvent('InitiateCheckout', getBookMetaParams(book), eventId);
};

export const trackBookPurchase = (book, eventId) => {
  if (!isMetaTrackedBook(book)) return;
  trackMetaEvent('Purchase', getBookMetaParams(book), eventId);
};
